export const parseLocation = (locationString) => {
  let locationInput = locationString;
  if (typeof locationInput === 'object' && locationInput !== null && locationInput.name) {
    locationInput = locationInput.name;
  }

  if (typeof locationInput !== 'string') {
    return { country: null, region: null, city: null };
  }

  const parts = locationInput.split(',').map(part => part.trim());

  if (parts.length === 1) {
    return { country: parts[0], region: null, city: null };
  }

  if (parts.length === 2) {
    return { country: parts[1], region: parts[0], city: null };
  }

  if (parts.length === 3) {
    return { country: parts[2], region: parts[1], city: parts[0] };
  }

  return { country: null, region: null, city: null };
};